const Description = (props) => {
  const { content } = props;
  return (
    <>
      {content
        .split('\n')
        .filter(line => line.trim() !== '')
        .map((line, index) => (
          <p key={index}>{line}</p>
        ))}
    </>
  );
};

export default Description;
